import { useParams } from 'react-router-dom';
import { sendNewPassword } from '../../configs/auth';
import { useState } from 'react';

const NewPassword = () => {

    const { token } = useParams();

    const [passwords, setPasswords] = useState({
        firstNewPassword: '',
        secondNewPassword: ''
    });

    const [error, setError] = useState(false);
    const [errorText, setErrorText] = useState("");

    const [showPassword, setShowPassword] = useState({
        firstNewPassword: false,
        secondNewPassword: false
    });

    const togglePasswordVisibility = (field) => {
        setShowPassword((prev) => ({ ...prev, [field]: !prev[field] }));
    };

    const handlePasswordChange = (e) => {
        const { id, value } = e.target;
        setPasswords((prev) => ({ ...prev, [id]: value }));
    };

    const sendPassword = async (e) => {
        e.preventDefault();

        if (passwords.firstNewPassword !== passwords.secondNewPassword) {
            setError(true);
            setErrorText("A jelszavak nem egyeznek!");
            return;
        }
    
        // Reguláris kifejezés a jelszó ellenőrzésére (kisbetű, nagybetű, szám, speciális karakter)
        const passwordStrengthRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*(),.?":{}|<>]).{8,}$/;
    
        // Ha nem felel meg a jelszó az erősségi követelményeknek
        if (!passwordStrengthRegex.test(passwords.firstNewPassword)) {
            setError(true);
            setErrorText("A jelszónak legalább 8 karakter hosszúnak kell lennie, és tartalmaznia kell kis- és nagybetűt, számot, valamint speciális karaktert is.");
            return;
        }

        sendNewPassword(passwords.firstNewPassword, token);
        
    };

    return (
        <div className="container-fluid d-flex justify-content-center align-items-center p-0">
            <div className='col-lg-5 col-md-9 col-11 my-5 p-4 d-flex flex-column justify-content-center align-items-center border shadow'>

                <h4 className="mb-4">Jelszó frissítése</h4>

                <form className='d-flex flex-column col-lg-7 col-10'>

                    {/* Új jelszó mező */}
                    <div className="form-floating mb-3 position-relative">
                        <input
                            type={showPassword.firstNewPassword ? 'text' : 'password'}
                            className="form-control"
                            id="firstNewPassword"
                            placeholder="Új jelszó"
                            minLength="8"
                            value={passwords.firstNewPassword}
                            onChange={handlePasswordChange}
                            required
                        />
                        <label htmlFor="firstNewPassword">Új jelszó</label>
                        <span
                            className="position-absolute top-50 end-0 translate-middle-y me-3 cursor-pointer"
                            onClick={() => togglePasswordVisibility('firstNewPassword')}
                        >
                            <i className={`bi ${showPassword.firstNewPassword ? 'bi-eye-slash' : 'bi-eye'}`} aria-hidden="true"></i>
                        </span>
                    </div>

                    {/* Új jelszó ismétlés mező */}
                    <div className="form-floating mb-3 position-relative">
                        <input
                            type={showPassword.secondNewPassword ? 'text' : 'password'}
                            className="form-control"
                            id="secondNewPassword"
                            placeholder="Új jelszó mégegyszer"
                            minLength="8"
                            value={passwords.secondNewPassword}
                            onChange={handlePasswordChange}
                            required
                        />
                        <label htmlFor="secondNewPassword">Új jelszó mégegyszer</label>
                        <span
                            className="position-absolute top-50 end-0 translate-middle-y me-3 cursor-pointer"
                            onClick={() => togglePasswordVisibility('secondNewPassword')}
                        >
                            <i className={`bi ${showPassword.secondNewPassword ? 'bi-eye-slash' : 'bi-eye'}`} aria-hidden="true"></i>
                        </span>
                    </div>
                    <p className={`${error ? 'text-danger' : 'd-none'}`}>{errorText}</p>

                    <div className="col-12 d-flex justify-content-center">
                        <button className='btn btn-home-primary my-3' onClick={(e) => sendPassword(e)}>Küldés</button>
                    </div>

                </form>

            </div>
        </div>
    );
};

export default NewPassword;
